export default __webpack_public_path__ + "partner_8937a82.png";